export const ROUTES = {
  HOME: "/",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_OF_SERVICE: "/terms-of-service",
  CONTACT: "/contact",
  PORTFOLIO: "/portfolio",
  CHECKLIST: "/checklist",
  ABOUT: "/about",
  PRICING: "/pricing"
};
